import { render, staticRenderFns } from "./WelcomeEdit.vue?vue&type=template&id=5365934d"
import script from "./welcomeEdit.ts?vue&type=script&lang=js&external"
export * from "./welcomeEdit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports